/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

import Navbar from "../../../components/Navbar";
import SalesAnalytics from "../../../components/Payments/Sales";
import { backendUrlByEnv } from "../../../constants/routes";

const Sales = () => {
  // const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.payments?.hasSalesAnalyticsAccess) {
      // navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <SalesAnalytics ROOT_URL={ROOT_URL} />
    </>
  );
};

export default Sales;
